"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignInLogin = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../atoms/LogoImage/index");

var _index2 = require("../../atoms/ScreenHeader/index");

var _index3 = require("../../atoms/GeneralButton/index");

var _index4 = require("../../atoms/CheckBox/index");

var _TagAndInput = require("../TagAndInput");

var _variables = require("../../../global-files/variables");

var _react = require("react");

var _LogoLoading = require("../LogoLoading");

var _reactRouterDom = require("react-router-dom");

var _showPassword = _interopRequireDefault(require("../../../assets/images/editField/showPassword.png"));

var _axios = _interopRequireDefault(require("axios"));

var _jsxRuntime = require("react/jsx-runtime");

var SignInLogin = function SignInLogin(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyEmail = _useState2[0],
      setEmptyEmail = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      invalidEmail = _useState4[0],
      setInvalidEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emptyPassword = _useState6[0],
      setEmptyPassword = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showErrors = _useState8[0],
      setShowErrors = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      signInError = _useState10[0],
      setSignInError = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      upgradePlanRedirect = _useState14[0],
      setUpgradePlanRedirect = _useState14[1];

  var validate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var valid, email, password, session, userGroup, response, user, company;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSignInError("");
              setShowErrors(true);
              e.preventDefault();
              valid = true;
              email = document.querySelector("#emailInput").value.trim();
              password = document.querySelector("#passwordInput").value;
              !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email) ? setInvalidEmail(true) : setInvalidEmail(false);

              if (email === "") {
                valid = false;
                setEmptyEmail(true);
              } else {
                setEmptyEmail(false);
              }

              if (password === "") {
                valid = false;
                setEmptyPassword(true);
              } else {
                setEmptyPassword(false);
              }

              if (!valid) {
                _context.next = 45;
                break;
              }

              _context.prev = 10;
              setLoading(true);
              _context.next = 14;
              return props.Auth.signIn(email, password);

            case 14:
              session = _context.sent;

              if (!(session.challengeName === "NEW_PASSWORD_REQUIRED")) {
                _context.next = 20;
                break;
              }

              props.setUser(session);
              props.setPaso(8);
              _context.next = 38;
              break;

            case 20:
              userGroup = session.signInUserSession.accessToken.payload["cognito:groups"];

              if (!userGroup.includes(props.users)) {
                _context.next = 36;
                break;
              }

              sessionStorage.setItem("auth", true);
              sessionStorage.setItem("jwt", session.signInUserSession.idToken.jwtToken);
              _context.next = 26;
              return _axios.default.get(process.env.REACT_APP_USER_ENDPOINT, {
                headers: {
                  Authorization: session.signInUserSession.idToken.jwtToken
                }
              });

            case 26:
              response = _context.sent;
              user = JSON.parse(response.data.body).data[0];
              company = JSON.parse(response.data.body).data[1];
              caches.keys().then(function (names) {
                names.forEach(function (name) {
                  var _caches;

                  (_caches = caches) === null || _caches === void 0 ? void 0 : _caches.delete(name);
                });
              });
              user.src = "https://".concat(process.env.REACT_APP_IMAGES_PROFILE_BUCKET, ".s3.amazonaws.com/id-").concat(user.id_user, "/").concat(user.id_user, ".png?").concat(new Date().getTime());
              sessionStorage.setItem("user", JSON.stringify(user));
              sessionStorage.setItem("company", JSON.stringify(company));
              setUpgradePlanRedirect(true);
              _context.next = 38;
              break;

            case 36:
              setSignInError("NotAuthorizedException");
              setLoading(false);

            case 38:
              _context.next = 45;
              break;

            case 40:
              _context.prev = 40;
              _context.t0 = _context["catch"](10);
              console.log(_context.t0);
              setLoading(false);

              if (_context.t0.code === "NotAuthorizedException") {
                setSignInError("NotAuthorizedException");
              } else if (_context.t0.code === "UserNotConfirmedException") {
                sessionStorage.setItem("email", JSON.stringify(email));
                props.setPaso(5);
              } else {
                setSignInError("Error");
              }

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 40]]);
    }));

    return function validate(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    sessionStorage.getItem("resetPasswordProcess") && sessionStorage.removeItem("resetPasswordProcess");
  }, []);
  (0, _react.useEffect)(function () {
    if (upgradePlanRedirect) setLoading(false);
  }, [upgradePlanRedirect]);

  var closeEye = function closeEye(e) {
    var input = document.getElementById("passwordInput");
    var eye = document.getElementById("Eye");

    if (input.type === "password") {
      input.type = "text";
      eye.style.opacity = 0.8;
    } else {
      input.type = "password";
      eye.style.opacity = 0.2;
    }
  };

  return loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoLoading.LogoLoading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: "home-login",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "main-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.LogoImage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "credenciales",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.ScreenHeader, {
            fontFamily: _variables.FontFamily.AvenirNext,
            color: _variables.GlobalColors.s5,
            text: "Ingresa tus credenciales"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "user",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
            inputType: "text",
            label: "Nombre de usuario",
            inputPlaceHolder: "username@contentoh.com",
            inputId: "emailInput",
            onKeyDown: function onKeyDown(e) {
              switch (e.key) {
                case "Enter":
                  validate(e);
                  break;

                default:
                  break;
              }
            }
          })
        }), showErrors && emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Ingrese su correo"
        }), invalidEmail && !emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Ingrese un correo v\xE1lido"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "password",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
            inputType: "password",
            label: "Contraseña",
            inputPlaceHolder: "Escribe tu contraseña",
            inputId: "passwordInput",
            onKeyDown: function onKeyDown(e) {
              switch (e.key) {
                case "Enter":
                  validate(e);
                  break;

                default:
                  break;
              }
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _showPassword.default,
            alt: "show password",
            className: "icon",
            id: "Eye",
            onClick: function onClick(e) {
              closeEye(e);
            }
          })]
        }), showErrors && emptyPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Ingrese su contrase\xF1a"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "select",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index4.CheckBox, {
            label: "Mantener sesión activada",
            id: "chk-default",
            className: "active-left"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            onClick: function onClick() {
              return props.setPaso(10);
            },
            className: "active-right",
            children: "Olvid\xE9 mi contrase\xF1a"
          })]
        }), showErrors && signInError === "NotAuthorizedException" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Correo o contrase\xF1a incorrectos"
        }), showErrors && signInError === "Error" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Ha habido un problema al iniciar sesi\xF3n"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "button-right",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.Button, {
            buttonType: "general-default-button",
            label: "Iniciar sesión",
            onClick: function onClick(e) {
              return validate(e);
            }
          })
        }), props.registration && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "new-login",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            className: "pre-registro",
            onClick: function onClick() {
              props.setPaso(1);
              sessionStorage.setItem("nuevoRegistro", JSON.stringify({
                name: "",
                lastName: "",
                email: "",
                position: "",
                country: "",
                phone: "",
                commercialName: "",
                companyName: "",
                rfc: "",
                adress: ""
              }));
              sessionStorage.setItem("countryCode", JSON.stringify("+52"));
            },
            children: ["\xBFA\xFAn no tienes cuenta?", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: " Reg\xEDstrate"
            })]
          })
        })]
      })
    }), upgradePlanRedirect && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Redirect, {
      to: {
        pathname: "/dashboard"
      }
    })]
  });
};

exports.SignInLogin = SignInLogin;